import { useSelector } from "react-redux";

import { getDashboardLayers } from "../../ducks/dashboard/selectors";
import { setDashboardLayer as setDashboardLayerAction } from "../../ducks/dashboard/dashboard";
import { useAction } from "../useAction";

export const useDashboardLayers = () => {
  const layers = useSelector(getDashboardLayers);
  const setDashboardLayer = useAction(setDashboardLayerAction);

  return { layers, setDashboardLayer };
};
